export const stylesChart = {
  heightBarChart: "349px",
  heightAreaChart: "400px",
  heightStackedHorizontalBarChart: "395px",
  heightStackedHorizontalBarChartWithoutLegends: "350px",
  heightDonutChart: "400px",
};